






















import {Component, Vue, Ref, Prop} from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {ProxySettingItem} from "@/store/settings/proxy_settings/types";
import {SelectWings} from "wings-ui-components";

@Component({components: {SelectWings}})
export default class proxySettingsForm extends Vue {
  @Prop({ required: true }) value!: number;

  @Ref('validator') validator: any;
  @Getter("proxySettings") proxySettings!: ProxySettingItem[];

  get modelValue() {
    return this.value;
  }
  set modelValue(newValue: number) {
    this.$emit("input", newValue);
  }
}
